import React, { useState } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import { graphql, useStaticQuery } from 'gatsby'

import Hemiciclo from '../Hemiciclo'
import Wrapper from '@/components/Feature/Elegidos/Wrapper'
import Alternativas from '@/components/Feature/Elegidos/Alternativas'
import groupBy from '@/util/groupBy'
import colorCalc from '@/util/colorCalc'
import Barra from '@/components/Feature/Elegidos/Barra'
import Sharer from '@/components/UI/Sharer'

const Card = ({ title, description, elegidos, pregunta, path }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          urlwoslash
          hashtags
          twitterHandle
          siteName
          domain
        }
      }
    }
  `)

  const { diputados, senadores, senadoresEnEjercicio } = elegidos
  const [tabIndex, setTabIndex] = useState(0)
  const todosLosSenadores = [...senadoresEnEjercicio, ...senadores]
  const sharerstring = `${pregunta.slug}: ${pregunta.descripcion} Revisa las respuestas del congreso electo 2021 - ${site.siteMetadata.siteName}`
  const sharerpath = `${site.siteMetadata.domain}${path}`
  return (
    <div className="px-2 text-center card">
      <div className="container max-w-4xl pt-16 mx-auto card-body">
        <h1 className="leading-tight card-title">{title}</h1>
        <div className="text-left card-text ">{description}</div>
        <Sharer url={sharerpath} title={sharerstring} />
      </div>
      <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
        <TabList>
          <Tab>Diputados</Tab>
          <Tab>Senadores (todos)</Tab>
          {/* <Tab>Senadores Electos</Tab>
          <Tab>Senadores En Ejercicio</Tab> */}
        </TabList>
        <TabPanel>
          <CardContent elegidos={diputados} pregunta={pregunta} />
        </TabPanel>
        <TabPanel>
          <CardContent elegidos={todosLosSenadores} pregunta={pregunta} />
        </TabPanel>
        {/* <TabPanel>
          <CardContent elegidos={senadores} pregunta={pregunta} />
        </TabPanel>
        <TabPanel>
          <CardContent elegidos={senadoresEnEjercicio} pregunta={pregunta} />
        </TabPanel> */}
      </Tabs>
    </div>
  )
}

const CardContent = ({ elegidos, pregunta }) => {
  const { sobreEstaPregunta } = pregunta
  const colors = [
    '#e6f598',
    '#abdda4',
    '#66c2a5',
    '#3288bd',
    '#5e4fa2',
    '#9e0142',
    '#d53e4f',
    '#f46d43',
    '#fdae61',
    '#fee08b',
  ]

  //filtrar respuestas por contexto de pregunta
  //en diputados array, agregar prop color de círculo a partir de pregunta abc
  //ordenar por color de círculo
  //ordenar pregunta orden contexto pregunta

  // console.log('pregunta en contexto', pregunta, diputados)

  const byAnswer = groupBy(elegidos, pregunta.campoEnPlanilla)

  const sortedKeys = pregunta.orden.split('-').map(orden => {
    // console.log('ordesn', orden)
    let obj = Object.keys(byAnswer).find(enunciado => {
      return enunciado.startsWith(orden)
    })

    if (typeof obj === 'undefined') {
      obj =
        'No retirar ninguna central a carbón, ya que ninguna fuente de generación eléctrica debiese estar prohibida.'
    }

    return obj
  })

  sortedKeys.push('undefined')

  const byAnswerArray = sortedKeys.map((answer, index) => {
    return {
      name: answer === 'undefined' ? 'No respondió' : answer,
      color:
        answer === 'undefined'
          ? 'rgb(204, 204, 204)'
          : colorCalc(index, pregunta.campoEnPlanilla.replace('_', ''), colors),
      seats: byAnswer[answer] ? byAnswer[answer] : [],
    }
  })

  const joined = byAnswerArray.reduce((acc, curr) => {
    return [...acc, ...curr.seats]
  }, [])

  const barArray = [
    {
      title: 'Por Lista',
      obj: groupBy(joined, 'lista'),
    },
    {
      title: 'Por Partido Político',
      obj: groupBy(joined, 'partidoPolitico'),
    },
    {
      title: 'Por Edad',
      obj: groupBy(joined, 'rangoDeEdad'),
    },
    {
      title: 'Por Sexo',
      obj: groupBy(joined, 'sexo'),
    },
  ]

  return (
    <Wrapper>
      <div className="cardcontent ">
        <div>
          <Hemiciclo width={500} height={250} data={byAnswerArray} />
        </div>
        <div>
          <Alternativas data={byAnswerArray} total={elegidos.length} />
        </div>

        {barArray.map(bar => (
          <Barra
            key={bar.title}
            title={bar.title}
            obj={bar.obj}
            campo={pregunta.campoEnPlanilla}
            alternativas={sortedKeys}
            colors={colors}
          />
        ))}
      </div>
    </Wrapper>
  )
}

export default Card
